import React from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress, DialogActions } from "@mui/material";

export default function CarrierDialogStandardActions({
  onCancel,
  onSubmit,
  submitting,
  submitLabel,
  cancelLabel = "Cancel",
}) {
  return (
    <DialogActions>
      <Button onClick={onCancel} color="primary">
        {cancelLabel}
      </Button>
      <Button onClick={onSubmit} color="primary" variant="contained" disabled={submitting}>
        {submitting ? <CircularProgress size={24} /> : submitLabel}
      </Button>
    </DialogActions>
  );
}

CarrierDialogStandardActions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string,
};
